export const DISCONNECT_GOOGLE = 'disconnect-google';

const disconnectGoogle = () => ({
  type: DISCONNECT_GOOGLE,
});

export default disconnectGoogle;
